import { createAction, props } from '@ngrx/store';
import { RideGroupAlert } from 'src/app/models/ride-group-alert';
import { RideGroupMessage } from 'src/app/models/ride-group-message';

export enum GroupRideMessageActions {
    setGroupRideMessages = '[group ride messages] set messages',
    appendGroupRideMessages = '[group ride messages] append messages',
    setGroupRideAlerts = '[group ride messages] set alerts',
    setGroupRideMessageTime = '[group ride messages] set time',
    setHasNewMessages = '[group ride messages] set has new messages',
    setHasNewAlerts = '[group ride messages] set has new alerts',
    noop = '[group ride messages] do nothing',
}

export const SetGroupRideMessages = createAction(
    GroupRideMessageActions.setGroupRideMessages,
    props<{ messages: RideGroupMessage[] }>()
);

export const AppendGroupRideMessages = createAction(
    GroupRideMessageActions.appendGroupRideMessages,
    props<{ messages: RideGroupMessage[] }>()
);

export const SetGroupRideAlerts = createAction(
    GroupRideMessageActions.setGroupRideAlerts,
    props<{ alerts: RideGroupAlert[] }>()
);

export const SetGroupRideMessageTime = createAction(
    GroupRideMessageActions.setGroupRideMessageTime,
    props<{ time: string }>()
);
export const SetHasNewMessages = createAction(
    GroupRideMessageActions.setHasNewMessages,
    props<{ hasNewMessages: boolean }>()
);
export const SetHasNewAlerts = createAction(
    GroupRideMessageActions.setHasNewAlerts,
    props<{ hasNewAlerts: boolean }>()
);

export const Noop = createAction(GroupRideMessageActions.noop);
